export const DistancesRun = Object.freeze([
  { key: 0, description: 'new' },
  { key: 1, description: '0 - 50 km (0 - 31 mi)' },
  { key: 2, description: '50 - 100 km (31 - 62 mi)' },
  { key: 3, description: '100 - 200 km (62 - 124 mi)' },
  { key: 4, description: '200 - 300 km (124 - 186 mi)' },
  { key: 5, description: '300 - 400 km (186 - 248 mi)' },
  { key: 6, description: '400 - 600 km (248 - 372 mi)' },
  { key: 7, description: '600 - 800 km (372 - 497 mi)' },
  { key: 8, description: '800+ km (497+ mi)' },
]);
